module.exports = __webpack_public_path__ + "img/Playtest_Journey_Select.6c6fc226.jpg";